import type {Job,JobStatus} from './types';
export const isCurrentJob=(job:Pick<Job,'status'>)=>job.status==='active'||job.status==='upcoming';
export const jobStatusLabels:Record<JobStatus,string>={active:'Đang tuyển',upcoming:'Sắp mở',paused:'Tạm dừng',closed:'Đã đóng',historical:'Tư liệu lịch sử',unknown:'Cần xác minh'};
export const fold=(text:string)=>text.toLocaleLowerCase('vi').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/đ/g,'d');
export function formatDate(date:string|null){
 if(!date)return 'Chưa rõ ngày đăng';
 const value=new Date(/^\d{4}-\d{2}-\d{2}$/.test(date)?date+'T00:00:00Z':date);
 if(Number.isNaN(value.getTime()))return 'Chưa rõ ngày đăng';
 return new Intl.DateTimeFormat('vi-VN',{day:'2-digit',month:'2-digit',year:'numeric',timeZone:'UTC'}).format(value);
}
export const unique=(items:string[])=>[...new Set(items)].sort((a,b)=>a.localeCompare(b,'vi'));

// Preserve source wording; soften titles stored entirely in capitals for display.
export function sentenceTitle(value:string){
 if(value!==value.toLocaleUpperCase('vi-VN'))return value;
 return (value.charAt(0)+value.slice(1).toLocaleLowerCase('vi-VN')).replace(/\b(nibelc|itw|ivs|idcj|imcj)\b/gi,word=>word.toUpperCase());
}
